import { Location } from "@angular/common";
import { Component, OnInit, ViewChild } from "@angular/core";
import { FormGroup } from "@angular/forms";
import { Router } from "@angular/router";
import { finalize, first } from "rxjs/operators";
import { AuthenticationService } from "../../../../core/authentication/authentication.service";
import { DynamicFormComponent } from "../../../../shared/components/dynamic-form/dynamic-form.component";
import { NotificationService } from "../../../../shared/components/notification/notification.service";
import { UserInfo } from "../../../../shared/types/user-info";
import { ConfigurableOption } from "../configurable-options.type";
import { ConfigurableOptionService } from "../configurable-options.service";
import { CreateConfigurableOptionService, ICreateConfigurableOptionForm } from "./create-configurable-option.service";

@Component({
  selector: "app-create-configurable-option",
  templateUrl: "./create-configurable-option.component.html",
  styleUrls: ["./create-configurable-option.component.scss"],
  providers: [CreateConfigurableOptionService],
})
export class CreateConfigurableOptionComponent implements OnInit {
  @ViewChild(DynamicFormComponent) dynamicForm: DynamicFormComponent;
  currentUser: UserInfo;
  createLocationsForm: FormGroup;
  questions: any;

  constructor(
    public location: Location,
    private router: Router,
    private configsService: ConfigurableOptionService,
    private questionsService: CreateConfigurableOptionService,
    private notificationService: NotificationService,
    private authenticationService: AuthenticationService,
  ) {
    this.currentUser = this.authenticationService.currentUserInfo;
  }

  ngOnInit(): void {
    this.questionsService.generateQuestions({}).subscribe((qs) => {
      this.questions = qs;
    });
  }

  goBack(): void {
    this.location.back();
  }

  onSubmit(values: ICreateConfigurableOptionForm): void {
    this.configsService
      .createConfigurableOption({ ...values })
      .pipe(finalize(() => this.dynamicForm.enable()))
      .subscribe(
        (ip: ConfigurableOption) => {
          this.notificationService.success("Configurable Option successfully created");
          this.router.navigate([`/configurable-options/${ip.id}`]);
        },
        (error) => {
          this.notificationService.error(error || "Could not create configurable option");
        },
      );
  }
}
